import * as React from 'react';
import { StatusActionsProps } from './status-actions.types';
import { useStatusActionsController } from './status-actions.controller';
import { Invited } from './components/invited';
import { Reviewed } from './components/reviewed';
import { IncompleteQuestionnaires } from './components/incomplete-questionnaires';
import { SubmittedQuestionnaires } from './components/submitted-questionnaires';
import { RenamePedigreeOnSubmit } from './components/rename-pedigree-on-submit';

import './status-actions.styles.scss';

export const StatusActions: React.FC<StatusActionsProps> = (props) => {
  const { 
    getFieldsForAfterThisDateField,
    getFoldersForAfterThisDateField,
    folders,
    emailTemplates,
  } = useStatusActionsController(props);

  const { 
    errors,
    questionnaire,
    onChange,
    getFolders,
    getFields,
    showConfirmMessage,
    onUnintendedIncompleteInactive,
    showErrorMessage
  } = props;

  return (
    <div className="FhqDesignToolStatusActions">
      <Invited
        errors={errors}
        folders={folders}
        questionnaire={questionnaire}
        onChange={onChange}
      />
      <Reviewed 
        errors={errors}
        emailTemplates={emailTemplates}
        folders={folders}
        questionnaire={questionnaire}
        onChange={onChange}
      />
      <IncompleteQuestionnaires
        errors={errors} 
        getFields={getFieldsForAfterThisDateField}
        getFolders={getFoldersForAfterThisDateField}
        questionnaire={questionnaire}
        onChange={onChange}
        showConfirmMessage={showConfirmMessage}
        onUnintendedIncompleteInactive={onUnintendedIncompleteInactive}
      />
      <SubmittedQuestionnaires 
        errors={errors}
        folders={folders}
        questionnaire={questionnaire}
        onChange={onChange}
      />
      <RenamePedigreeOnSubmit 
        questionnaire={questionnaire}
        onChange={onChange}
        getFields={getFields}
        getFolders={getFolders}
        showErrorMessage={showErrorMessage}
        errors={errors}
      />
    </div>
  );
};